<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl sm:text-xl">Ciao, <label class="font-bold">{{profileName}}</label></label><br>
  <label *ngIf="profileSex == 'M'" class="w-full text-900 text-4xl sm:text-xl">Sei pronto per una nuova <label class="font-bold">avventura</label>?</label>
  <label *ngIf="profileSex == 'F'" class="w-full text-900 text-4xl sm:text-xl">Sei pronta per una nuova <label class="font-bold">avventura</label>?</label>

</div>

<app-header-dashboard [showBtnRedirect]="true"></app-header-dashboard>

<div class="surface-section mt-3 px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">Annunci in evidenza</label>
</div>

<div class="col-12 justify-content-center px-4 md:px-6 lg:px-8 table-mobile-scroll" loading="eager">
  <div class="col-12 mt-2" *ngIf="lstJobPostEvidence.length > 0">
    <p-table [value]="lstJobPostEvidence"
             [styleClass]="'primary'"
             [tableStyle]="{ 'min-width': '10rem' }"
             [paginator]="true"
             [rows]="10"
             currentPageReportTemplate="Elementi totali : {totalRecords}"
             [rowsPerPageOptions]="[10, 25, 50]">
      <ng-template pTemplate="header">
        <tr>
          <th class="bg-primary">Titolo</th>
          <th class="bg-primary">Provincia</th>
          <th class="bg-primary">Luogo</th>
          <th class="bg-primary">Filiale</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr class="cursor-pointer" (click)="showDetails(record.IdCommessaAnnuncio,true)">
          <td>{{record.Titolo}}</td>
          <td>{{record.ProvinciaNome}}</td>
          <td>{{record.Luogo}}</td>
          <td>{{record.FilialeCommessa}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-12 mt-2" *ngIf="lstJobPostEvidence.length === 0">
    <label class="w-full">Non ci sono annunci in evidenza</label>
  </div>
</div>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">Le tue candidature</label>
</div>

<div class="col-12 flex flex-wrap justify-content-center px-4 md:px-6 lg:px-8 table-mobile-scroll" loading="eager">
  <p-table [value]="lstCandidature"
           [styleClass]="'primary'"
           [tableStyle]="{ 'min-width': '10rem' }"
           [paginator]="true"
           [rows]="10"
           currentPageReportTemplate="Elementi totali : {totalRecords}"
           [rowsPerPageOptions]="[10, 25, 50]">
    <ng-template pTemplate="header">
      <tr>
        <th class="bg-primary">Titolo Annuncio</th>
        <th class="bg-primary">Data Candidatura</th>
        <th class="bg-primary">Provenienza</th>
        <th class="bg-primary">Filiale</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr class="cursor-pointer" (click)="showDetails(record.IdCommessaAnnuncio,false) ">
        <td>{{record.Titolo}}</td>
        <td>{{record.DataCandidaturaStr}}</td>
        <td>{{record.PostingProviderDesc}}</td>
        <td>{{record.Filiale}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12">Non hai ancora effettuato candidature</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [header]="headerDetailsDialog" [(visible)]="showDetailsDialog" [modal]="true" (onHide)="onhideModal()" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">

  <app-details [jobPostId]="jobPostSelected.IdCommessaAnnuncio" *ngIf="jobPostSelected.IdCommessaAnnuncio> 0"
               [showBtnCandidate]="showBtnCandidate"
    (close)="closeModal($event)">
  </app-details>


</p-dialog>

